// extracted by css-extract-rspack-plugin
export default {"employerConstructorEditSnippet":"employer-constructor-edit-snippet--LtL5vbBnEOAvPxyp"};